var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 254,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    x: 1127.5,
    y: 1578,
    stroke: "#707070",
    fill: "#fff",
    height: 254,
    width: 314,
    className: "a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-107.624 333.48 106.234)",
    stroke: "#702082",
    id: "svg_3",
    strokeWidth: "1px",
    strokeMiterlimit: 10,
    fill: "none",
    d: "m202.26178,88.17674c-0.93417,-112.36402 80.83569,-208.57915 170.8938,-73.12492c80.15082,121.5316 141.52647,241.02555 33.55984,248.69412c-117.36631,-5.58716 -195.47715,-51.80983 -204.45251,-175.5692",
    className: "c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineImage);
export default __webpack_public_path__ + "static/media/line-image.8b351896007c22562ec6418bdc774a0e.svg";
export { ForwardRef as ReactComponent };